export default __webpack_public_path__ + "media/CICD.97c35b33aa88e2bbf638c17d6e705383.svg";